import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { LoggerService } from 'src/shared/logger/logger.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Levels } from 'src/shared/logger/levels.enum';
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';
import { state } from 'src/system-profile-manager/shared/state.enum';
import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';


@Component({
  templateUrl: './rollback.component.html',
  styleUrls: ['./rollback.component.css'],
  providers: [SystemProfileService]
})
export class RollbackComponent implements OnInit {
  listOfFIlesNames: string[];
  currentConfigName: string = null;
  currentConfigString: string = null;
  rolledBackSelectedName: string = null;
  rolledBackSelectedString: string = null;

  constructor(
    public dialogRef: MatDialogRef<RollbackComponent>,
    private systemService: SystemProfileService,
    private loggerService: LoggerService,
    @Inject(MAT_DIALOG_DATA) public systemIpAndName: { system_ip, system_name },
    private _snackBar: MatSnackBar, private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.systemService.getConfigFiles(this.systemIpAndName.system_ip).subscribe(res => {
      if (res["data"] && res["data"].length > 0) {
        this.currentConfigName = res["data"][0];
        this.systemService.getConfigFileByName(this.systemIpAndName.system_ip, this.currentConfigName).subscribe(fileRes => {
          this.currentConfigString = fileRes["data"];
          this.currentConfigString.replace("ï»¿", "")
        }, err => {
          this.loggerService.log("RollbackComponent", err.message, Levels.error)
          this.openSnackBar(err.error.message ? err.error.message : "Error while sending data", "Error");
        })
        res["data"].shift();
        this.listOfFIlesNames = res["data"];
      }
    }, err => {
      this.loggerService.log("RollbackComponent", err.message, Levels.error)
      this.openSnackBar(err.error.message ? err.error.message : "Error while sending data", "Error");
    })
  }

  onSubmitData() {

  }

  onNgModelChange(event) {
    this.systemService.getConfigFileByName(this.systemIpAndName.system_ip, event[0]).subscribe(fileRes => {
      this.rolledBackSelectedString = fileRes["data"];
    }, err => {
      this.loggerService.log("RollbackComponent", err.message, Levels.error)
      this.openSnackBar(err.error.message ? err.error.message : "Error while sending data", "Error");
    })
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Rollback System", message: `Are you sure you want to rollback system with name = ${this.systemIpAndName.system_name} and ip = ${this.systemIpAndName.system_ip} from the current configuration: ${this.currentConfigName} to selected configuration: ${this.rolledBackSelectedName}.` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.systemService.rollbackSystemConfiguration(this.systemIpAndName.system_ip, this.rolledBackSelectedName[0]).subscribe(res => {
          res["data"].enable_phonebook = res["data"].enable_phonebook == '1' ? "On" : "Off"
          res["data"].enable_sip = res["data"].enable_sip == '1' ? "On" : "Off"
          res["data"].enable_h323 = res["data"].enable_h323 == '1' ? "On" : "Off";

          this.loggerService.log("RollbackComponent", `Rollback for unit with ip =${this.systemIpAndName.system_ip} is completed`, Levels.info)
          this.openSnackBar('Rollback is completed', "Success");
          this.dialogRef.close(res["data"]);
        }, err => {
          this.loggerService.log("RollbackComponent", err.message, Levels.error)
          this.openSnackBar(err.error.message ? err.error.message : "Error while sending data", "Error");
        })

      }
    });
  }

}
